import React from 'react';
import { hot } from 'react-hot-loader';
import { Route, Switch } from 'react-router-dom';

import ManualRoute, { baseUrl as manualUrl } from './modules/Manual/Routes';

const Pages = () => {
  return (
    <Switch>
      <Route path={manualUrl} component={ManualRoute} />
    </Switch>
  );
};

export default hot(module)(Pages);
